import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@material-ui/core";
import {
  ValidatorForm,
} from "react-material-ui-form-validator";
import { finalizarSolicitud } from "../../../../actions/empadronamiento/Empadronamiento";

export const ModalMotivoFin = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    props.setMotivoFin("");
  }, []);

  const onChangeTextAreaHandler = (e) => {
    props.setMotivoFin(e.target.value);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    dispatch(finalizarSolicitud(props.idSolicitud, props.motivoFin, props.setOpenModalGestionar));
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2} style={{ margin: "2rem 3" }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={4}
                label="Nota"
                name="motivoFin"
                value={props.motivoFin}
                onChange={onChangeTextAreaHandler}
              />
            </Grid>
          </Grid>
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            {props.motivoFin.length > 0 && <Button type="submit" variant="contained" disabled={props.disabled} color="primary">
              Aceptar
            </Button>}
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
